export default {"src":"/_next/static/media/1.75eebc7f.svg","height":39,"width":39,"blurWidth":0,"blurHeight":0};